'use client';

import type { FC } from 'react';
import { ScreenContent, ScreenFixedTop, ScreenTabBar } from '../../screen';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import { InfoCard } from '../../components/ui/InfoCard';
import { InfoRow } from '../../components/ui/InfoRow';
import translations from './ContactsScreen.translations';

const COMPANY = 'YaTT "GINIYATULIN MAKSIM VLADIMIROVICH"';
const INN = '32103920251745';
const EMAIL = 'support@cs-shot.uz';
const ADDRESS = 'Toshkent sh, Mirabad tumani, Tarasa Shevchenko kochasi, 21A';
const PHONE = '+998 33 123 31 13';

export const ContactsScreen: FC = () => {
  const { t } = useLocalTranslation(translations);

  return (
    <>
      <ScreenFixedTop title={t('title')} />
      <ScreenTabBar />
      <ScreenContent>
        <div className="mx-auto flex max-w-2xl flex-col gap-4 p-4 pb-8">
          <InfoCard>
            <h2 className="m-0 mb-2 text-base font-bold text-white break-words">{COMPANY}</h2>
            <div className="flex flex-col">
              <InfoRow label={t('labelInn')}>{INN}</InfoRow>
              <InfoRow label={t('labelEmail')}>
                <a className="text-accent-blue hover:underline" href={`mailto:${EMAIL}`}>
                  {EMAIL}
                </a>
              </InfoRow>
              <InfoRow label={t('labelAddress')}>{ADDRESS}</InfoRow>
              <InfoRow label={t('labelPhone')}>
                <a className="text-accent-blue hover:underline" href={`tel:${PHONE.replace(/\s/g, '')}`}>
                  {PHONE}
                </a>
              </InfoRow>
            </div>
          </InfoCard>
        </div>
      </ScreenContent>
    </>
  );
};
